// extracted by mini-css-extract-plugin
export var addToCartButton = "_u4-b";
export var arrowButtonContainer = "_u4-9";
export var arrowButtonIcon = "_u4-a";
export var carouselArrowButton = "_u4-6";
export var carouselElementContainer = "_u4-1";
export var left = "_u4-7";
export var productDisplayCarouselContainer = "_u4-0";
export var productTileContainer = "_u4-2";
export var productTileImage = "_u4-4";
export var productTileImageContainer = "_u4-3";
export var productTileTitle = "_u4-5";
export var right = "_u4-8";
export var sliderOverflow = "_u4-c";